import { breakpoints, useMediaQuery } from '@coursera/cds-core';

const useIsMobile = (): boolean => {
  const mobileBreakpoint = breakpoints.down('xs');
  const isMobile = useMediaQuery(mobileBreakpoint);

  return isMobile;
};

export default useIsMobile;
